export const getUserProfilePicture = (pictureGuid: string) =>
  `${process.env.NEXT_PUBLIC_BASE_URL}/user-photos/${pictureGuid}.png`;
